module.exports = __webpack_public_path__ + "static/media/rainForecast.54ab1c75.png";